import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/i18n'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => import('@/views/Main.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        meta: { titleKey: 'meta.homeTitle' },
        component: () => import('@/views/Home/index.vue'),
      },
      {
        path: '/services/acquiring',
        name: 'Acquiring',
        meta: { titleKey: 'meta.acquiringTitle'},
        component: () => import('@/views/Services/Acquiring.vue'),
      },
      {
        path: '/services/collection',
        name: 'Collection',
        meta: { titleKey: 'meta.collectionTitle'},
        component: () => import('@/views/Services/Collection.vue'),
      },
      {
        path: '/services/exchange',
        name: 'Exchange',
        meta: { titleKey: 'meta.exchangeTitle' },
        component: () => import('@/views/Services/Exchange.vue'),
      },
      {
        path: '/services/payment',
        name: 'Payment',
        meta: { titleKey: 'meta.paymentTitle' },
        component: () => import('@/views/Services/Payment.vue'),
      },

      {
        path: '/compliance',
        name: 'Compliance',
        meta: { titleKey: 'meta.complianceTitle' },
        component: () => import('@/views/Compliance/index.vue'),
      },
      {
        path: '/about',
        name: 'About',
        meta: { titleKey: 'meta.aboutTitle' },
        component: () => import('@/views/About/index.vue'),
      },
      {
        path: '/customer',
        name: 'Customer',
        meta: { titleKey: 'meta.customerTitle' , hidOther: true },
        component: () => import('@/views/Customer/index.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const title = to.meta.titleKey ? i18n.t(to.meta.titleKey) : i18n.t('meta.siteName');
  if (to.name === 'Home') {
    document.title = title;
  } else {
    document.title = `${title} - ${i18n.t('meta.siteName')}`;
  }
  next();
});

export default router;
